import type { ReactNode } from 'react';

export const symbol_do_not_disturb_on_total_silence: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M654.5-311.5Q726-383 726-483t-71.5-171.5Q583-726 483-726t-171.5 71.5Q240-583 240-483t71.5 171.5Q383-240 483-240t171.5-71.5ZM396-453q-13 0-21.5-8.5T366-483q0-13 8.5-21.5T396-513h167q13 0 21.5 8.5T593-483q0 13-8.5 21.5T563-453H396Zm84 373q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-156t86-127Q252-817 325-848.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 82-31.5 155T763-197.5q-54 54.5-127 86T480-80Zm0-60q142 0 241-99.5T820-480q0-142-99-241t-241-99q-141 0-240.5 99T140-480q0 141 99.5 240.5T480-140Zm0-340Z"
		/>
	</svg>
);
